module.exports = new __parcel__URL__("rassvetLogoWithName.fdd5ba11.png").toString();